module.exports = __webpack_public_path__ + "bd3e3195640804126ab9d4f93042502f.svg";